

















// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import Edit from '@/components/administration/forfait/edit/EditContent.vue'
import { getDefaultAloForfait, AloForfait } from '@/models/alo/AloForfait';
import { toStringDictionary } from '@/utils/groupBy';

@Component({
  name: 'ReadContent',    
   props: {
    forfait:{      
      default:getDefaultAloForfait()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit}
})
export default class ReadContent extends Vue {
  private forfait!:AloForfait
  private loading!:boolean


  get configuration(){
    return this.$store.myGetters.configuration
  }

  edit() { (this.$refs.edit as Edit).edit(this.forfait) }
}
